import searchUrlMap from './searchUrlMap';
import { getRoutesFromLocalStorage } from '@ott/search-history';

const DAY_TIME = 86400000;

export const checkNewSearchRoute = (searchHistoryRoutes, searchRoute) => {
  const now = Date.now();

  return searchHistoryRoutes.filter((item) => {
    const startDate = new Date(item.route.fromDate).getTime();

    return item.route.routeString !== searchRoute.route.routeString && now - startDate <= DAY_TIME;
  });
};

export const checkSearchHistoryFromStorage = (searchHistoryRoutes) => {
  const now = Date.now();

  return searchHistoryRoutes.filter((item) => {
    const startDate = new Date(item.route.fromDate).getTime();

    return now - startDate <= DAY_TIME;
  });
};

export function getFormattedRouteFromLocalStorage(initialRoute) {
  let routeFromLS = initialRoute;

  if (!initialRoute) {
    const routes = getRoutesFromLocalStorage('historyRoutes', 0, checkSearchHistoryFromStorage);
    routeFromLS = routes && routes[0];
  }

  if (!routeFromLS) {
    return null;
  }

  const { route, query } = routeFromLS;

  const directions = route.directions.map((dir) => {
    return {
      ...dir,
      date: new Date(dir.date),
    };
  });

  const newRoute = {
    ...route,
    directions,
    toDate: new Date(route.toDate),
    fromDate: new Date(route.fromDate),
  };

  const serviceClass = searchUrlMap.serviceClass;
  const adultsCount = searchUrlMap.adultsCount;
  const childrenAges = searchUrlMap.childrenAges;

  return {
    route: newRoute,
    serviceClass: query[serviceClass],
    adultsCount: query[adultsCount],
    childrenAges: query[childrenAges] ? query[childrenAges].split('_') : [],
  };
}
